import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_2 = { class: "p-field w-full" }
const _hoisted_3 = {
  key: 0,
  class: "p-error"
}
const _hoisted_4 = { class: "p-field w-full" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-field w-full" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field w-full  mb-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "description",
  class: "text-body2"
}, "Keterangan", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "font-semibold pb-4 border-bottom-blue-grey-lighten-5" }, "Detail Pembayaran", -1)
const _hoisted_11 = { class: "flex items-center justify-between py-3 border-bottom-blue-grey-lighten-5" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    class: "h-6 w-6 mr-2",
    style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "#607D8B",
      d: "M441.884 109.647A32.029 32.029 0 0 0 415.669 96H48a32.036 32.036 0 0 0-32 32v248h41.082a67.982 67.982 0 0 0 133.836 0h122.164a67.982 67.982 0 0 0 133.836 0H496V194.521a23.886 23.886 0 0 0-4.338-13.763zM180 128h144v96H180zm-132 0h100v96H48zm76 272a36 36 0 1 1 36-36a36.04 36.04 0 0 1-36 36zm256 0a36 36 0 1 1 36-36a36.04 36.04 0 0 1-36 36zm84-56h-19.006a68 68 0 0 0-129.988 0H188.994a68 68 0 0 0-129.988 0H48v-88h416zm0-120H356v-96h59.669L464 197.043z"
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold" }, "Diterima Kru Bis")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_14 = { class: "flex items-center justify-between py-3 border-bottom-blue-grey-lighten-5" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    class: "h-6 w-6 mr-2",
    style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      fill: "none",
      cx: "12",
      cy: "7",
      r: "3"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M12 2C9.243 2 7 4.243 7 7s2.243 5 5 5s5-2.243 5-5s-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3s3 1.346 3 3s-1.346 3-3 3zm9 11v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h2v-1c0-2.757 2.243-5 5-5h4c2.757 0 5 2.243 5 5v1h2z",
      fill: "#607D8B"
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold" }, "Diterima Agen")
], -1)
const _hoisted_16 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_17 = { class: "flex items-center justify-between py-3 border-bottom-blue-grey-lighten-5 mb-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    class: "h-6 w-6 mr-2",
    style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createVNode("g", { fill: "#607D8B" }, [
      /*#__PURE__*/_createVNode("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z" }),
      /*#__PURE__*/_createVNode("path", { d: "M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z" })
    ])
  ]),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold" }, "Non Tunai")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold" }, "Total", -1)
const _hoisted_22 = { class: "color-primary" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-between p-4" }, [
  /*#__PURE__*/_createVNode("p", null, "Manifest")
], -1)
const _hoisted_24 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_25 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_26 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_27 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_28 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_29 = { class: "w-full mt-6 absolute bottom-0 left-0 right-0 px-6 py-6 bg-white" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Simpan & Print")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Batalkan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Card = _resolveComponent("Card")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: `Tambah Loading Manifest`,
    visible: _ctx.dialogLoadingManifest,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogLoadingManifest = $event)),
    class: "dialog-voucher relative",
    modal: true,
    dismissableMask: true,
    onHide: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideDialog()))
  }, {
    default: _withCtx(() => [
      _createVNode("form", {
        id: "form-add-manifest",
        class: "mb-14",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitLoadingManifest(!_ctx.v$.$invalid)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("label", {
              for: "noPol",
              class: {'p-error':_ctx.v$.noPol.$invalid && _ctx.submitted, 'text-body2': true}
            }, "Nomor Polisi Bus", 2),
            _createVNode(_component_InputText, {
              id: "noPol",
              class: "input-primary w-full mt-1 uppercase rounded-lg",
              name: "noPol",
              modelValue: _ctx.v$.noPol.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.noPol.$model = $event)),
              type: "text"
            }, null, 8, ["modelValue"]),
            _createVNode("div", null, [
              ((_ctx.v$.noPol.$invalid && _ctx.submitted) || _ctx.v$.noPol.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_3, _toDisplayString(_ctx.v$.noPol.required.$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("label", {
              for: "driverName",
              class: {'p-error':_ctx.v$.driverName.$invalid && _ctx.submitted, 'text-body2': true}
            }, "Nama Supir", 2),
            _createVNode(_component_InputText, {
              id: "driverName",
              class: "input-primary w-full mt-1 rounded-lg",
              name: "driverName",
              modelValue: _ctx.v$.driverName.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.driverName.$model = $event)),
              type: "text"
            }, null, 8, ["modelValue"]),
            _createVNode("div", null, [
              ((_ctx.v$.driverName.$invalid && _ctx.submitted) || _ctx.v$.driverName.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_5, _toDisplayString(_ctx.v$.driverName.required.$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("label", {
              for: "stewardName",
              class: {'p-error':_ctx.v$.stewardName.$invalid && _ctx.submitted, 'text-body2': true}
            }, "Nama Pramugara", 2),
            _createVNode(_component_InputText, {
              id: "stewardName",
              class: "input-primary w-full mt-1 rounded-lg",
              name: "stewardName",
              modelValue: _ctx.v$.stewardName.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.stewardName.$model = $event)),
              type: "text"
            }, null, 8, ["modelValue"]),
            _createVNode("div", null, [
              ((_ctx.v$.stewardName.$invalid && _ctx.submitted) || _ctx.v$.stewardName.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.stewardName.required.$message), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_InputText, {
            id: "description",
            class: "input-primary w-full mt-1 rounded-lg",
            name: "description",
            modelValue: _ctx.dataAdd.description,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataAdd.description = $event)),
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_Card, { class: "card-no-shadow card-item-category mb-4" }, {
          content: _withCtx(() => [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              (_ctx.detailAdd.DetailPembayaran)
                ? (_openBlock(), _createBlock("p", _hoisted_13, "Rp " + _toDisplayString(new Number(_ctx.detailAdd.DetailPembayaran.BusTerima).toLocaleString('id-ID')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              (_ctx.detailAdd.DetailPembayaran)
                ? (_openBlock(), _createBlock("p", _hoisted_16, "Rp " + _toDisplayString(new Number(_ctx.detailAdd.DetailPembayaran.AgenTerima).toLocaleString('id-ID')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              (_ctx.detailAdd.DetailPembayaran)
                ? (_openBlock(), _createBlock("p", _hoisted_19, "Rp " + _toDisplayString(new Number(_ctx.detailAdd.DetailPembayaran.NonTunai).toLocaleString('id-ID')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode("p", null, [
                _createVNode("b", _hoisted_22, "Rp " + _toDisplayString(new Number(_ctx.detailAdd.PendapatanManifest).toLocaleString('id-ID')), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Card, { class: "card-no-shadow card-p-0 card-item-category mb-4" }, {
          header: _withCtx(() => [
            _hoisted_23
          ]),
          content: _withCtx(() => [
            (_ctx.detailAdd.Manifest)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  value: _ctx.detailAdd.Manifest,
                  class: "table-og body-td-x-0",
                  responsiveLayout: "scroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { header: "No" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_24, _toDisplayString(slotProps.index+1), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Nomor Resi" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_25, _toDisplayString(slotProps.data.Resi), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Jml Koli" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_26, _toDisplayString(slotProps.data.Jumlah), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Pendapatan" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_27, "Rp " + _toDisplayString(new Number(slotProps.data.GrandTotal).toLocaleString('id-ID')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Pembayaran" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_28, _toDisplayString(slotProps.data.JenisPembayaran), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 32),
      _createVNode("div", _hoisted_29, [
        _createVNode(_component_Button, {
          class: "btn-primary text-black mr-3 px-10 py-1",
          type: "submit",
          form: "form-add-manifest"
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black px-10 py-1",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideDialog()))
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}